import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { FiscalYear } from '../FiscalYear'
import { selectTopYears } from './store/slice'

export const FiscalYearListRadio = ({ children, setValue, keySetting }) => {
  const topYears = useSelector(selectTopYears)

  useEffect(() => {
    if (topYears.length) {
      setValue(`setting.${keySetting}`, topYears[0])
    }
  }, [topYears])

  return (
    <FiscalYear isShowLoading={false}>
      <div className="dFlex" style={{ gap: 15, flexWrap: 'wrap' }}>
        {topYears.map((year) => {
          return (
            <div key={year}>
              {children({
                title: year?.toString(),
                value: year,
              })}
            </div>
          )
        })}
      </div>
    </FiscalYear>
  )
}
